<div class="toolbar-container">
  <ng-container *hasAsset>
    <semeris-search-box
      *permissions="undefined"
      (filterChange)="search($event)"
      [loading]="searchLoading$ | async"
      [results]="results$ | async"
      [transactionLookup]="transactionLookup$ | async"
      (addToCompare)="onAddToCompare($event)"
      (removeFromComparison)="onRemoveFromComparison($event)"
      (marketCompare)="onMarketCompare($event)"
      (toggleTopic)="onToggleTopic($event)"
      (reset)="onResetSearch()"
      [disabled]="blocked$ | async">
    </semeris-search-box>
  </ng-container>
  @if (userInfo$ | async; as userInfo) {
    <div class="toolbar-button-controls">
      @if (verifiedUser$ | async) {
        @if (onboardingTenant$ | async) {
          <semeris-warning-chip class="onboarding">
            Your account is being set up.<br />
            Meanwhile, try <a (click)="onToggleGuidedTourSidebar()">Guided Tours</a>.
          </semeris-warning-chip>
        }
      }
      @let impersonatedTenant = impersonatedTenant$ | async;
      @let impersonatedUser = impersonatedUser$ | async;
      @if (impersonatedTenant || impersonatedUser) {
        <semeris-warning-chip>
          <mat-icon>warning</mat-icon>
          <div class="text">
            <span>
              @if (isReadOnlyImpersonation$ | async) {
                <b>Read-only</b> &middot;
              }
              Viewed as
              @if (impersonatedUser) {
                <b>{{ impersonatedUser | userNameResolver$ | async }}</b>
              }
              @if (impersonatedUser && impersonatedTenant) {
                in
              }
              @if (impersonatedTenant) {
                <b>{{ impersonatedTenant | tenantNameResolver$ | async }}</b>
              }</span
            ><br />
            <span
              ><a (click)="onExitImpersonation()">Exit</a> or change in
              <a [routerLink]="['/', 'settings', 'profile']">Profile Settings</a></span
            >
          </div>
        </semeris-warning-chip>
      }
      @if (notSupportedBrowser) {
        <semeris-not-supported-browser-indicator></semeris-not-supported-browser-indicator>
      }
      <ng-container *hasAsset>
        <semeris-manager-approval-dropdown></semeris-manager-approval-dropdown>

        <button
          *permissions="[Permissions.WRITE_CATALOG]"
          semerisButton
          variant="text"
          [matMenuTriggerFor]="catalogMenu"
          class="catalog-tools"
          disableRipple="true">
          <span class="display-large">Catalog Tools</span>
          <mat-icon aria-hidden="false">expand_more</mat-icon>
        </button>
        <mat-menu #catalogMenu="matMenu" xPosition="before" class="catalog-toolbar-dropdown">
          <button (click)="onRunOrphanDealCleaner()" mat-menu-item aria-label="Run orphan deal cleaner">
            Run orphan deal cleaner
          </button>
          <button
            (confirm)="onRunCsvReport()"
            confirmTitle="Run CSV report"
            confirmText="Are you sure you want to run the CSV report?"
            confirmColor="accent"
            confirmButtonText="Run CSV report"
            mat-menu-item
            aria-label="Run CSV report">
            Run CSV report
          </button>
        </mat-menu>
        <semeris-xray-control
          *permissions="undefined"
          [enabledXRayOptions]="xRayOptions$ | async"
          (xRayOptionsChange)="onXRayOptionsChange($event)"></semeris-xray-control>
        <button
          *permissions="[Permissions.READ_COMMENT]"
          semerisIconButton
          color="accent"
          (click)="onToggleConversationSidebar()"
          fastTooltip="Notes"
          class="notes-button">
          <mat-icon>comment</mat-icon>
        </button>
        <semeris-default-label-selector *permissions="[Permissions.WRITE_COMMENT]"></semeris-default-label-selector>
        <semeris-deals-indicator
          *permissions="undefined"
          [deals]="deals$ | async"
          [loading]="comparisonLoading$ | async"
          (addExamples)="addExamples()"
          (remove)="onRemoveFromComparison($event)"
          (clear)="onClear()"></semeris-deals-indicator>
        <!--
              <button
                *permissions="[Permissions.WRITE_DOCUMENT]"
                class="filter-options"
                [routerLink]="['/', SemerisRoutes.documents.root, SemerisRoutes.documents.create]"
                disableRipple="true"
                semerisIconButton
                fastTooltip="Upload document"
                color="accent"
                >
                <mat-icon>upload</mat-icon>
              </button>
              -->
      </ng-container>
      <!-- Interface switch (classic ⇄ next) -->
      @if (showDeploymentToggle) {
        <div class="sui-swap sui-swap-sm sui-swap-primary" role="group" aria-label="Interface" *permissions="[Permissions.READ_NEXT_UI]">
          @for (option of deploymentVariants; track option.variant) {
            <button
              class="sui-badge sui-swap-item"
              [attr.aria-pressed]="deploymentVariant === option.variant"
              [suiTooltip]="option.tooltip"
              suiTooltipPlacement="bottom"
              (click)="onSwitchDeployment(option.variant)">
              {{ option.label }}
            </button>
          }
        </div>
      }
      <button
        semerisButton
        variant="text"
        [matMenuTriggerFor]="menu"
        disableRipple="true"
        [attr.aria-label]="userInfo.name">
        <span class="relative inline-flex"
          ><semeris-avatar [imageSrc]="userInfo.picture" [name]="userInfo.name" [size]="avatarSize$ | async"></semeris-avatar
          ><semeris-connection-status-indicator class="absolute bottom-0 right-0"></semeris-connection-status-indicator
        ></span>
        <span class="display-large">&nbsp;{{ userInfo.name }}&nbsp;</span>
        <mat-icon aria-hidden="false">expand_more</mat-icon>
      </button>
      <!--
              <button
                *permissions="[Permissions.READ_GUIDED_TOUR]"
                disableRipple="true"
                semerisIconButton
                fastTooltip="Guided Tours"
                color="accent"
                (click)="onToggleGuidedTourSidebar()"
                >
                <mat-icon>school</mat-icon>
              </button>
              -->
      @if (verifiedUser$ | async) {
        <semeris-help-icon></semeris-help-icon>
      }
      <mat-menu #menu="matMenu" xPosition="before" class="toolbar-dropdown">
        <button [routerLink]="['/', 'settings', 'profile']" mat-menu-item aria-label="Profile Settings">
          <mat-icon color="accent">person</mat-icon>
          <span>Profile Settings</span>
        </button>
        <mat-divider></mat-divider>
        <ng-container *permissions="[Permissions.READ_MY_TENANT]">
          <button [routerLink]="['/', 'settings', 'tenant']" mat-menu-item aria-label="Tenant Settings">
            <mat-icon color="accent">manage_accounts</mat-icon>
            <span>Tenant Settings</span>
          </button>
          <mat-divider></mat-divider>
        </ng-container>
        @if (verifiedUser$ | async) {
          <button
            [routerLink]="['/', SemerisRoutes.help.root, 'main.html']"
            mat-menu-item
            color="accent"
            aria-label="User Guide">
            <mat-icon color="accent">help_outline</mat-icon>
            <span>User Guide</span>
          </button>
        }
        <button
          *permissions="[Permissions.READ_GUIDED_TOUR]"
          [routerLink]="['/', 'home']"
          (click)="onToggleGuidedTourSidebar()"
          mat-menu-item
          aria-label="Guided Tours">
          <mat-icon color="accent">school</mat-icon>
          <span>Guided Tours</span>
        </button>
        <mat-divider></mat-divider>
        <button (click)="onFeedback()" mat-menu-item aria-label="Send us a message">Send us a message</button>
        @if (verifiedUser$ | async) {
          <button (click)="onFeedback()" mat-menu-item aria-label="Help us improve">Help us improve</button>
        }
        <a href="https://semeris.com" target="_blank" rel="noopener noreferrer" mat-menu-item>Visit semeris.com</a>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()" aria-label="Logout">
          <mat-icon color="accent">logout</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
    </div>
  }
</div>
